<template>
	<div class="main-wrapper">
		<div class="py-[6vh] md:px-[20%] grid grid-cols-1 gap-8">
			<template v-if="storyData">
				<StoryblokComponent
					v-for="blok in storyItems"
					:key="blok._uid"
					:blok="blok"
				/>
			</template>
			<ErrorPage
				v-else
				:status-code="statusCode"
				:status-message="statusMessage"
				:message="message"
				:back-home="backHome"
			/>
		</div>
	</div>
</template>

<script setup>
import ErrorPage from "~/layers/base/components/ErrorPage.vue";

const props = defineProps({
	statusCode: {
		type: Number,
		default: 404
	},
	statusMessage: {
		type: String,
		default: "Not Found"
	},
	message: {
		type: String,
		default: "Sorry, the page you are looking for could not be found."
	},
	backHome: {
		type: String,
		default: "Go back home"
	}
});

const config = useRuntimeConfig();
const storyData = ref(null);
const storyblokLanguage = useStoryblokLanguage();

if (props.statusCode === 404) {
	const storyblokData = await useAsyncStoryblok(
		`${config.public.errorPageContentKey}`,
		{
			version: config.public.storyblokVersion,
			language: storyblokLanguage.value,
			resolve_links: "url"
		}
	);

	storyData.value = storyblokData.value?.content;
}

const storyItems = computed(() => storyData.value?.body || []);

useHead({
	title: () =>
		storyData?.value?.Title || `${props.statusCode} - ${props.statusMessage}`
});
</script>
